import { Instagram, Youtube, Facebook, Linkedin, Eye, Heart, MessageCircle, ExternalLink } from "lucide-react";
import { Reveal, SectionHeading, CountUp } from "@/components/Reveal";
import { SOCIAL_SHOWCASE } from "@/data/content";

const ICONS = { Instagram, Youtube, Facebook, Linkedin };

const PhoneMockup = ({ item, index }) => {
  const Icon = ICONS[item.icon];
  return (
    <Reveal delay={index * 0.12}>
      <a
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`social-mockup-${item.platform.toLowerCase().replace(/\s+/g, "-")}`}
        className="group block"
        title={`Watch on ${item.platform} — replace this link with your own post in src/data/content.js`}
      >
        <div className="phone-frame relative aspect-[9/19] max-w-[270px] mx-auto overflow-hidden transition-transform duration-500 group-hover:-translate-y-2">
          <div className="phone-notch" />
          <video
            src={item.video}
            poster={item.poster}
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-black/40" />
          <div className="absolute top-9 left-0 right-0 flex items-center justify-center gap-2">
            <Icon className="w-4 h-4 text-white" />
            <span className="text-[11px] font-semibold text-white tracking-wide">{item.platform}</span>
          </div>
          <div className="absolute bottom-0 inset-x-0 p-4">
            <p className="text-xs font-bold text-white">{item.handle}</p>
            <p className="mt-1 text-[11px] text-zinc-300 leading-snug">{item.caption}</p>
            <div className="mt-3 flex items-center justify-between text-[11px] text-zinc-200">
              <span className="inline-flex items-center gap-1"><Eye className="w-3.5 h-3.5 text-indigo-400" /><CountUp value={item.views} /></span>
              <span className="inline-flex items-center gap-1"><Heart className="w-3.5 h-3.5 text-purple-400" /><CountUp value={item.likes} /></span>
              <span className="inline-flex items-center gap-1"><MessageCircle className="w-3.5 h-3.5 text-blue-400" /><CountUp value={item.comments} /></span>
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-400 bg-black/40">
            <span className="glass rounded-full px-4 py-2 text-xs font-semibold text-white inline-flex items-center gap-2">
              Watch <ExternalLink className="w-3.5 h-3.5" />
            </span>
          </div>
        </div>
        <p className="mt-4 text-center text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 group-hover:text-indigo-300 transition-colors duration-300">
          {item.platform}
        </p>
      </a>
    </Reveal>
  );
};

const SocialShowcase = () => (
  <section id="social" data-testid="social-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="glow-blob w-[30rem] h-[30rem] bg-purple-600/10 top-20 -right-40" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        align="center"
        caption="Content That Travels"
        title={<>One street moment. <span className="text-gradient">Every feed. Every platform.</span></>}
        description="Latest Instagram Reels, YouTube Shorts, Facebook videos and LinkedIn posts from our campaigns. Tap any phone to watch — these are placeholders ready to be swapped with your own reels and shorts."
        testId="social-heading"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-6">
        {SOCIAL_SHOWCASE.map((item, i) => (
          <PhoneMockup key={item.platform} item={item} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default SocialShowcase;
